import React from "react";
import "./TeamMembers.scss";

const TeamMembers = ({ teamMembers }) => {
    const orderedTeamMembers = [...(teamMembers || [])].sort(
        (first, second) =>
            Number(second?.ticketRouting === true) -
            Number(first?.ticketRouting === true)
    );

    return (
        <div className='team__members'>
            {orderedTeamMembers.slice(0, 3)?.map((member, i) => (
                <div className='team__members--member' key={i}>
                    <span className='team__members--text'>
                        {`${member?.firstName} ${member?.lastName}`}
                    </span>
                </div>
            ))}
            {orderedTeamMembers.length > 3 && (
                <div className='team__members--others'>
                    <span className='team__members--text'>
                        {`+${orderedTeamMembers.length - 3} others`}
                    </span>
                </div>
            )}
        </div>
    );
};

export default TeamMembers;
